import React from 'react'

const Privacy = () => {

    return (
        <div id="Container">
            <h1>Privacyverklaring</h1>
            <p>
                MKS-Dashboard en/of ander aanverwante services die MKS-Dashboard aanbied,
                gelegen op/gekoppeld aan https://mks-dashboard.github.io/, is verantwoordelijk voor de verwerking van gegevens. Zoals weergeven in deze privacyverklaring
            </p>

            <h2>Persoonsgegevens die wij verwerken:</h2>
            <p>
                MKS-Dashboard verwerkt je persoonsgegevens doordat je gebruik maakt van onze diensten en/of omdat je deze gegevens zelf aan ons verstrekt. Hieronder vind je een overzicht van de persoonsgegevens die wij verwerken:
                <ul>
                    <li>Gegevens over jouw activiteiten op onze website</li>
                </ul>
            </p>

            <h2>Bijzondere en/of gevoelige persoonsgegevens die wij verwerken</h2>
            <p>
                Onze website en/of dienst heeft niet de intentie gegevens te verzamelen over websitebezoekers die jonger zijn dan 16 jaar.
                Tenzij ze toestemming hebben van ouders of voogd.
                We kunnen echter niet controleren of een bezoeker ouder dan 16 is.
                Wij raden ouders dan ook aan betrokken te zijn bij de online activiteiten van hun kinderen,
                om zo te voorkomen dat er gegevens over kinderen verzameld worden zonder ouderlijke toestemming.
                Als je er van overtuigd bent dat wij zonder die toestemming persoonlijke gegevens hebben verzameld over een minderjarige,
                neem dan contact met ons op via centralistpiet2001@gmail.com, dan verwijderen wij deze informatie.
            </p>

            <h2>Met welk doel en op basis van welke grondslag wij persoonsgegevens verwerken</h2>
            <p>
                MKS-Dashboard verwerkt jouw persoonsgegevens voor de volgende doelen:
                <ul>
                    <li>Om goederen en diensten bij je af te leveren</li>
                    <li>MKS-Dashboard analyseert jouw gedrag op de website om daarmee de website te verbeteren en het aanbod van producten en diensten af te stemmen op jouw voorkeuren.</li>
                </ul>
            </p>

            <h2>Hoe lang we persoonsgegevens bewaren</h2>
            <p>
                MKS-Dashboard bewaart je persoonsgegevens niet langer dan strikt nodig is om de doelen te realiseren waarvoor je gegevens worden verzameld.
                Wij hanteren de volgende bewaartermijnen voor de volgende (categorieën) van persoonsgegevens:
                <ul>
                    <li>Gebruikersaccount naam: 14 dagen na laatste gebruik</li>
                    <li>statistische gegevens: 30 dagen na laatste invoer/ophaling</li>
                </ul>
            </p>

            <h2>Delen van persoonsgegevens met derden</h2>
            <p>
                MKS-Dashboard verstrekt uitsluitend aan derden en alleen als dit nodig is voor de uitvoering van onze overeenkomst met jou of om te voldoen aan een wettelijke verplichting.
            </p>

            <h2>Cookies, of vergelijkbare technieken, die wij gebruiken</h2>
            <p>
                MKS-Dashboard gebruikt alleen technische en functionele cookies.
                En analytische cookies die geen inbreuk maken op je privacy.
                Een cookie is een klein tekstbestand dat bij het eerste bezoek aan deze website wordt opgeslagen op jouw computer, tablet of smartphone.
                De cookies die wij gebruiken zijn noodzakelijk voor de technische werking van de website en jouw gebruiksgemak.
                Ze zorgen ervoor dat de website naar behoren werkt en onthouden bijvoorbeeld jouw voorkeursinstellingen.
                Ook kunnen wij hiermee onze website optimaliseren.
                Je kunt je afmelden voor cookies door je internetbrowser zo in te stellen dat deze geen cookies meer opslaat.
                Daarnaast kun je ook alle informatie die eerder is opgeslagen via de instellingen van je browser verwijderen.
            </p>

            <h2>Gegevens inzien, aanpassen of verwijderen</h2>
            <p>
                Je hebt het recht om je persoonsgegevens in te zien, te corrigeren of te verwijderen.
                Daarnaast heb je het recht om je eventuele toestemming voor de gegevensverwerking in te trekken
                of bezwaar te maken tegen de verwerking van jouw persoonsgegevens door MKS-Dashboard
                en heb je het recht op gegevensoverdraagbaarheid.
                Dat betekent dat je bij ons een verzoek kan indienen om de persoonsgegevens die wij van jou beschikken
                in een computerbestand naar jou of een ander,
                door jou genoemde organisatie, te sturen.
                Je kunt een verzoek tot inzage, correctie, verwijdering, gegevensoverdraging van je persoonsgegevens
                of verzoek tot intrekking van je toestemming of bezwaar op de verwerking van jouw persoonsgegevens
                sturen naar centralistpiet2001@gmail.com. Om er zeker van te zijn dat het verzoek tot inzage door jou is gedaan,
                dien je ons je UserID van het spel mee te sturen. Wij zullen u via deze weg een verificatie code sturen welke u in de mail ons moet toezenden om de gegevens te krijgen.
                We reageren zo snel mogelijk, maar binnen vier weken, op jouw verzoek.
            </p>

        </div >
    )
}

export default Privacy
